import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Services from "./views/Services.vue";
import Training from "./services/Training.vue";
import Research from "./services/Research.vue";
import SMEevents from "./services/SMEevents.vue";
import Venture from "./services/Venture.vue";
import Funding from "./services/Funding.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    },
    {
      path: "/services",
      name: "services",
      component: Services
    },
    { path: "/training", name: "training", component: Training },
    {
      path: "/research-development",
      name: "research-development",
      component: Research
    },
    { path: "/sme-events", name: "sme-events", component: SMEevents },
    {
      path: "/venture-management",
      name: "venture-management",
      component: Venture
    },
    {
      path: "/sme-funding",
      name: "sme-funding",
      component: Funding
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 60 }
      };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
